// export default function makeParseNumber() {
export default function makeParseNumber() {
    // Formateador de números
    const numberFormatter = new Intl.NumberFormat('en-US', {
        style: 'decimal',
        maximumFractionDigits: 2
    });

    const setNumberMask = (valueToParse) => {

        const cleanValue = valueToParse.replace(/,/g, '');

        const validNumber = /^-?\d*\.?\d*$/.test(cleanValue);

        if (!validNumber) {
            return;
        }

        if (cleanValue === '' || cleanValue === '.') {
            return {
                value: parseFloat(cleanValue),
                value_mask: valueToParse
            }
        }

        let [integerPart, decimalPart] = cleanValue.split('.');

        if (decimalPart !== undefined) {
            decimalPart = decimalPart.slice(0, 2); 
        }

        const formattedInteger = numberFormatter.format(parseFloat(integerPart || 0));

        const formattedValue = decimalPart !== undefined
            ? `${formattedInteger}.${decimalPart}` 
            : formattedInteger;

        return {
            value: parseFloat(cleanValue),
            value_mask: formattedValue
        }

    }

    return Object.freeze({
        setNumberMask
    })
}